import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  Buttons_Styles,
  Card_Styles,
  Cards_Types,
  Choices_Styles,
  DropDown_Styles,
  Field_Text_Styles,
  Field_date_time_Styles,
  MENU_BUTTON_FORM,
  c1,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";

@Component({
  selector: "app-button-position-component",
  templateUrl: "./button-position-component.component.html",
  styleUrls: ["./button-position-component.component.scss"],
})
export class ButtonPositionComponentComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
  ) {}

  @Input() button_id: string;
  @Input() config: any;
  mode: string;

  // default values
  icon: string;
  offCanvasSubscription: any;
  offcanvasColors = offcanvasColors;
  button: MenuButton;
  data: any;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  isAndroid: boolean;
  text_id: any;
  buttonFormTypes: typeof MENU_BUTTON_FORM = MENU_BUTTON_FORM;
  labelform: UntypedFormGroup;

  stylesChoices = [];
  card_types = [];
  sync = true;

  cornerOptions = [
    { key: 'none', label: 'no corner', tl: false, tr: false, br: false, bl: false },
    { key: 'all', label: 'all', tl: true, tr: true, br: true, bl: true },
    { key: 'top', label: 'top', tl: true, tr: true, br: false, bl: false },
    { key: 'bottom', label: 'bottom', tl: false, tr: false, br: true, bl: true },
    { key: 'top_left', label: 'top left', tl: true, tr: false, br: false, bl: false },
    { key: 'top_right', label: 'top right', tl: false, tr: true, br: false, bl: false },
    { key: 'bottom_right', label: 'bottom right', tl: false, tr: false, br: true, bl: false },
    { key: 'bottom_left', label: 'bottom left', tl: false, tr: false, br: false, bl: true },
    // { key: 'middle', label: 'middle', tl: false, tr: false, br: false, bl: false },
    // { key: 'middle_padding', label: 'mid padding', tl: false, tr: false, br: false, bl: false },
  ];

  ngOnInit() {
    this.field_id = "label";
    this.labelform = this.formBuilder.group({
      position: new UntypedFormControl("single"),
      size: new UntypedFormControl(1),
    });
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      },
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      },
    );
  }

  buttonIntialize(data) {
    this.data = data.data;
    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;

      this.labelform = this.formBuilder.group({
        position: new UntypedFormControl(
          this.isAndroid && this.button.button_corner_radius
            ? this.button.button_corner_radius.corners
            : !this.isAndroid && this.button.button_corner_radius_ios
              ? this.button.button_corner_radius_ios.corners
              : "single",
        ),
        size: new UntypedFormControl(
          this.isAndroid && this.button.button_corner_radius
            ? this.button.button_corner_radius.size
            : !this.isAndroid && this.button.button_corner_radius_ios
              ? this.button.button_corner_radius_ios.size
              : 1,
        ),
      });
    }
  }

  changePosition() {
    if (this.isAndroid || this.sync) {
      this.button.button_corner_radius = {...this.button.button_corner_radius, corners: this.labelform.value.position, size: this.labelform.value.size};
    }
    if (!this.isAndroid || this.sync) {
      this.button.button_corner_radius_ios = {...this.button.button_corner_radius_ios, corners: this.labelform.value.position, size: this.labelform.value.size};
    }
    this.updateButtonData();
  }

  selectCorner(key: string) {
    this.labelform.get('position')?.setValue(key);
    this.changePosition();
  }
  changeSize() {
    if (this.isAndroid || this.sync) {
      this.button.button_corner_radius = {...this.button.button_corner_radius , corners: this.labelform.value.position , size: this.labelform.value.size};
    }
    if (!this.isAndroid || this.sync) {
      this.button.button_corner_radius_ios = {...this.button.button_corner_radius_ios , corners: this.labelform.value.position , size: this.labelform.value.size};
    }
    this.updateButtonData();
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id,
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true,
    );
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
  }
}
